package br.com.htms.inspeccaocampo.form

import br.com.htms.inspeccaocampo.auth.AuthApi
import br.com.htms.inspeccaocampo.auth.AuthSession
import br.com.htms.inspeccaocampo.auth.AuthUser
import br.com.htms.inspeccaocampo.auth.RemoteInspection
import br.com.htms.inspeccaocampo.data.ObraCatalog
import br.com.htms.inspeccaocampo.data.ObraItem
import br.com.htms.inspeccaocampo.data.AlojamentoValidacao
import br.com.htms.inspeccaocampo.data.AppConfig
import br.com.htms.inspeccaocampo.data.ChecklistAlojamentoCatalog
import br.com.htms.inspeccaocampo.data.ComunicacaoOcorrenciasValidacao
import br.com.htms.inspeccaocampo.data.ConfigStore
import br.com.htms.inspeccaocampo.data.DraftStore
import br.com.htms.inspeccaocampo.data.ErroCampo
import br.com.htms.inspeccaocampo.data.FormChecklistAlojamento
import br.com.htms.inspeccaocampo.data.FormComunicacaoOcorrencias
import br.com.htms.inspeccaocampo.data.FormInspecao
import br.com.htms.inspeccaocampo.data.FormJson
import br.com.htms.inspeccaocampo.data.FormRelatorioFoto
import br.com.htms.inspeccaocampo.data.FormTipo
import br.com.htms.inspeccaocampo.data.FotoAnexo
import br.com.htms.inspeccaocampo.data.InspecaoCatalog
import br.com.htms.inspeccaocampo.data.InspecaoCompleta
import br.com.htms.inspeccaocampo.data.InspecaoStore
import br.com.htms.inspeccaocampo.data.InspecaoValidacao
import br.com.htms.inspeccaocampo.data.ItemConformidade
import br.com.htms.inspeccaocampo.data.ItemVerificacao
import br.com.htms.inspeccaocampo.data.RelatorioFotoCatalog
import br.com.htms.inspeccaocampo.data.RespostaConformidade
import br.com.htms.inspeccaocampo.data.RespostaSimNao
import br.com.htms.inspeccaocampo.data.RespostaTernaria
import br.com.htms.inspeccaocampo.data.SecaoSimNao
import br.com.htms.inspeccaocampo.data.TreinamentoDados
import br.com.htms.inspeccaocampo.data.semConteudoBase64
import br.com.htms.inspeccaocampo.data.temConteudoRascunho
import br.com.htms.inspeccaocampo.export.ExportNames
import br.com.htms.inspeccaocampo.export.JpegPdfBuilder
import br.com.htms.inspeccaocampo.export.SharedExcelBuilder
import br.com.htms.inspeccaocampo.export.SharedExporter
import br.com.htms.inspeccaocampo.platform.PhotoStampData
import br.com.htms.inspeccaocampo.platform.PlatformFiles
import br.com.htms.inspeccaocampo.platform.PlatformImage
import br.com.htms.inspeccaocampo.platform.PlatformServices
import br.com.htms.inspeccaocampo.platform.currentTimeMillis
import br.com.htms.inspeccaocampo.platform.formatDateBr
import br.com.htms.inspeccaocampo.platform.monthOf
import br.com.htms.inspeccaocampo.platform.yearOf
import br.com.htms.inspeccaocampo.util.AdminSenha
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import kotlinx.coroutines.withContext

enum class AppTab { HUB, FORM, HISTORICO, CONFIG }

data class HistoricoUiState(
    val exportandoId: Long? = null,
    val exportandoRemoteId: String? = null,
    val exportandoLote: Boolean = false,
    val exportandoConsolidado: Boolean = false,
    val mensagem: String? = null
)

/**
 * Controlador completo do app compartilhado (iOS e host CMP).
 */
class AppController {
    private val scope = CoroutineScope(SupervisorJob() + Dispatchers.Main)
    private val store = InspecaoStore()
    private val draftStore = DraftStore()
    private val configStore = ConfigStore()

    private val _tab = MutableStateFlow(AppTab.HUB)
    val tab: StateFlow<AppTab> = _tab.asStateFlow()

    private val _formTipoAtivo = MutableStateFlow(FormTipo.INSPECAO_CAMPO)
    val formTipoAtivo: StateFlow<FormTipo> = _formTipoAtivo.asStateFlow()

    private val _form = MutableStateFlow(FormInspecao(dataHorarioMs = currentTimeMillis()))
    val form: StateFlow<FormInspecao> = _form.asStateFlow()

    private val _relatorioForm = MutableStateFlow(FormRelatorioFoto(dataHorarioMs = currentTimeMillis()))
    val relatorioForm: StateFlow<FormRelatorioFoto> = _relatorioForm.asStateFlow()

    private val _checklistForm = MutableStateFlow(FormChecklistAlojamento(dataHorarioMs = currentTimeMillis()))
    val checklistForm: StateFlow<FormChecklistAlojamento> = _checklistForm.asStateFlow()

    private val _ocorrenciasForm = MutableStateFlow(FormComunicacaoOcorrencias(dataHorarioMs = currentTimeMillis()))
    val ocorrenciasForm: StateFlow<FormComunicacaoOcorrencias> = _ocorrenciasForm.asStateFlow()

    private val _erros = MutableStateFlow<List<ErroCampo>>(emptyList())
    val erros: StateFlow<List<ErroCampo>> = _erros.asStateFlow()

    private val _idEdicao = MutableStateFlow<Long?>(null)
    val idEdicao: StateFlow<Long?> = _idEdicao.asStateFlow()

    private val _mensagem = MutableStateFlow<String?>(null)
    val mensagem: StateFlow<String?> = _mensagem.asStateFlow()

    private val _capturandoGps = MutableStateFlow(false)
    val capturandoGps: StateFlow<Boolean> = _capturandoGps.asStateFlow()

    private val _modoTreinamento = MutableStateFlow(false)
    val modoTreinamento: StateFlow<Boolean> = _modoTreinamento.asStateFlow()

    private val _appConfig = MutableStateFlow(AppConfig.padrao())
    val appConfig: StateFlow<AppConfig> = _appConfig.asStateFlow()

    private val _assinaturaEditando = MutableStateFlow<String?>(null)
    val assinaturaEditando: StateFlow<String?> = _assinaturaEditando.asStateFlow()

    private val _inspecoes = MutableStateFlow<List<InspecaoCompleta>>(emptyList())
    val inspecoes: StateFlow<List<InspecaoCompleta>> = _inspecoes.asStateFlow()

    private val _historico = MutableStateFlow(HistoricoUiState())
    val historico: StateFlow<HistoricoUiState> = _historico.asStateFlow()

    private val _rascunhoRestaurado = MutableStateFlow(false)
    val rascunhoRestaurado: StateFlow<Boolean> = _rascunhoRestaurado.asStateFlow()

    private val _authUser = MutableStateFlow<AuthUser?>(null)
    val authUser: StateFlow<AuthUser?> = _authUser.asStateFlow()

    private val _authReady = MutableStateFlow(!AuthApi.isLoginRequired())
    val authReady: StateFlow<Boolean> = _authReady.asStateFlow()

    private val _remoteInspections = MutableStateFlow<List<RemoteInspection>>(emptyList())
    val remoteInspections: StateFlow<List<RemoteInspection>> = _remoteInspections.asStateFlow()

    private val _obrasAtivas = MutableStateFlow(ObraCatalog.seedAtivas())
    val obrasAtivas: StateFlow<List<ObraItem>> = _obrasAtivas.asStateFlow()

    val loginRequired: Boolean get() = AuthApi.isLoginRequired()
    val isAdmin: Boolean get() = _authUser.value?.isAdmin == true

    init {
        scope.launch {
            if (AuthApi.isLoginRequired()) {
                val restored = runCatching { AuthApi.restoreSession() }.getOrNull()
                _authUser.value = restored?.user
                _authReady.value = true
                if (restored != null) {
                    iniciarAposLogin()
                }
            } else {
                _authReady.value = true
                iniciarAposLogin()
            }
        }
    }

    private suspend fun iniciarAposLogin() {
        val cfg = withContext(Dispatchers.Default) { configStore.carregar() }
        _appConfig.value = cfg
        InspecaoCatalog.recarregar(cfg)
        carregarObrasAtivas()
        recarregarHistorico()
        _tab.value = AppTab.HUB
        val rascunho = withContext(Dispatchers.Default) { draftStore.carregar() }
        if (rascunho != null) {
            _form.value = rascunho.first
            _idEdicao.value = rascunho.second
            _formTipoAtivo.value = FormTipo.INSPECAO_CAMPO
            _rascunhoRestaurado.value = true
            _tab.value = AppTab.FORM
        }
    }

    /** Carrega obras ativas da API; fallback para seed embutido. */
    fun carregarObrasAtivas() {
        scope.launch {
            AuthApi.listObrasAtivas()
                .onSuccess { lista ->
                    if (lista.isNotEmpty()) _obrasAtivas.value = lista
                    else _obrasAtivas.value = ObraCatalog.seedAtivas()
                }
                .onFailure {
                    _obrasAtivas.value = ObraCatalog.seedAtivas()
                }
        }
    }

    fun onLoginSuccess(session: AuthSession) {
        _authUser.value = session.user
        _tab.value = AppTab.HUB
        scope.launch { iniciarAposLogin() }
    }

    fun logout() {
        AuthApi.logout()
        _authUser.value = null
        _remoteInspections.value = emptyList()
        _inspecoes.value = emptyList()
        _tab.value = AppTab.HUB
        _formTipoAtivo.value = FormTipo.INSPECAO_CAMPO
    }

    fun irPara(tab: AppTab) {
        _tab.value = tab
    }

    fun abrirFormulario(tipo: FormTipo) {
        val user = _authUser.value
        if (user != null && !user.canAccessForm(tipo)) {
            _mensagem.value = "Seu perfil não tem acesso a este formulário."
            _tab.value = AppTab.HUB
            return
        }
        _formTipoAtivo.value = tipo
        _erros.value = emptyList()
        _idEdicao.value = null
        when (tipo) {
            FormTipo.INSPECAO_CAMPO -> {
                _form.value = FormInspecao(dataHorarioMs = currentTimeMillis())
                capturarGps()
            }
            FormTipo.RELATORIO_FOTO_ALOJAMENTO -> {
                _relatorioForm.value = FormRelatorioFoto(dataHorarioMs = currentTimeMillis())
                capturarGpsRelatorio()
            }
            FormTipo.CHECKLIST_ALOJAMENTO -> {
                _checklistForm.value = FormChecklistAlojamento(dataHorarioMs = currentTimeMillis())
                capturarGpsChecklist()
            }
            FormTipo.RELATORIO_ALOJAMENTO -> {
                val ms = currentTimeMillis()
                _relatorioForm.value = FormRelatorioFoto(dataHorarioMs = ms)
                _checklistForm.value = FormChecklistAlojamento(dataHorarioMs = ms)
                capturarGpsRelatorioAlojamento()
            }
            FormTipo.COMUNICACAO_OCORRENCIAS -> {
                _ocorrenciasForm.value = FormComunicacaoOcorrencias(dataHorarioMs = currentTimeMillis())
                capturarGpsOcorrencias()
            }
        }
        _tab.value = AppTab.FORM
    }

    fun voltarAoHub() {
        _erros.value = emptyList()
        _tab.value = AppTab.HUB
    }

    /** Voltar da config: hub (formulários + histórico disponíveis para todos). */
    fun voltarDaConfig() {
        _tab.value = AppTab.HUB
    }

    fun consumirMensagem() {
        _mensagem.value = null
    }

    fun consumirAvisoRascunho() {
        _rascunhoRestaurado.value = false
    }

    fun limparMensagemHistorico() {
        _historico.value = _historico.value.copy(mensagem = null)
    }

    fun atualizar(block: (FormInspecao) -> FormInspecao) {
        _form.value = block(_form.value)
        persistirRascunhoDebounced()
    }

    fun atualizarItem(itemId: String, block: (ItemVerificacao) -> ItemVerificacao) {
        _form.value = _form.value.copy(
            itens = _form.value.itens.map { if (it.id == itemId) block(it) else it }
        )
        persistirRascunhoDebounced()
    }

    fun definirResposta(itemId: String, resposta: RespostaTernaria) {
        atualizarItem(itemId) { it.copy(resposta = resposta) }
    }

    fun adicionarFotoItem(itemId: String) {
        scope.launch {
            val captured = PlatformServices.capturePhoto()
            if (captured == null) {
                _mensagem.value = "Captura de foto cancelada ou indisponível."
                return@launch
            }
            val item = _form.value.itens.find { it.id == itemId }
            val stampedBytes = PlatformImage.applyStamp(
                captured.path,
                PhotoStampData(
                    tstResponsavel = _form.value.tstResponsavel,
                    pergunta = item?.titulo ?: itemId,
                    resposta = item?.resposta?.rotulo ?: "Sim",
                    responsavelFrente = _form.value.responsavelFrente,
                    localTexto = _form.value.localTexto,
                    dataHoraMs = currentTimeMillis(),
                    latitude = captured.latitude ?: _form.value.latitude,
                    longitude = captured.longitude ?: _form.value.longitude,
                    numeroInspecao = _idEdicao.value
                )
            )
            if (stampedBytes == null || stampedBytes.isEmpty()) {
                _mensagem.value =
                    "Não foi possível carimbar a foto. No iPhone, use a câmera do app " +
                        "(JPEG) — fotos HEIC da galeria não são suportadas no navegador."
                return@launch
            }
            // Embed a partir dos bytes do carimbo (não reler path — falha comum na Web).
            val embedded = embedPhotoBase64(stampedBytes)
            val path = PlatformServices.publishPhoto(captured.path)
            val foto = FotoAnexo(
                path = path,
                capturadoEm = currentTimeMillis(),
                latitude = captured.latitude ?: _form.value.latitude,
                longitude = captured.longitude ?: _form.value.longitude,
                conteudoBase64 = embedded
            )
            atualizarItem(itemId) {
                it.copy(fotos = it.fotos + foto, resposta = RespostaTernaria.SIM)
            }
        }
    }

    /** Compat com UI antiga. */
    fun adicionarFotoPlaceholder(itemId: String) = adicionarFotoItem(itemId)

    fun removerUltimaFotoItem(itemId: String) {
        atualizarItem(itemId) { item ->
            if (item.fotos.isEmpty()) item else item.copy(fotos = item.fotos.dropLast(1))
        }
    }

    fun removerFotoItem(itemId: String, foto: FotoAnexo) {
        atualizarItem(itemId) { item ->
            item.copy(fotos = item.fotos.filter { it.id != foto.id })
        }
    }

    fun definirRespostaSecao(campo: String, resposta: RespostaSimNao) {
        atualizarSecao(campo) { it.copy(resposta = resposta) }
    }

    fun atualizarDescricaoSecao(campo: String, descricao: String) {
        atualizarSecao(campo) { it.copy(descricao = descricao) }
    }

    fun adicionarFotoSecao(campo: String) {
        scope.launch {
            val captured = PlatformServices.capturePhoto()
            if (captured == null) {
                _mensagem.value = "Captura de foto cancelada ou indisponível."
                return@launch
            }
            val stampedBytes = PlatformImage.applyStamp(
                captured.path,
                PhotoStampData(
                    tstResponsavel = _form.value.tstResponsavel,
                    pergunta = if (campo == "acoesCorretivas") "Ações Corretivas" else campo,
                    resposta = "Sim",
                    responsavelFrente = _form.value.responsavelFrente,
                    localTexto = _form.value.localTexto,
                    dataHoraMs = currentTimeMillis(),
                    latitude = captured.latitude ?: _form.value.latitude,
                    longitude = captured.longitude ?: _form.value.longitude,
                    numeroInspecao = _idEdicao.value
                )
            )
            if (stampedBytes == null || stampedBytes.isEmpty()) {
                _mensagem.value =
                    "Não foi possível carimbar a foto. No iPhone, use a câmera do app " +
                        "(JPEG) — fotos HEIC da galeria não são suportadas no navegador."
                return@launch
            }
            val embedded = embedPhotoBase64(stampedBytes)
            val path = PlatformServices.publishPhoto(captured.path)
            val foto = FotoAnexo(
                path = path,
                capturadoEm = currentTimeMillis(),
                latitude = captured.latitude ?: _form.value.latitude,
                longitude = captured.longitude ?: _form.value.longitude,
                conteudoBase64 = embedded
            )
            atualizarSecao(campo) { it.copy(fotos = it.fotos + foto, resposta = RespostaSimNao.SIM) }
        }
    }

    fun adicionarFotoSecaoPlaceholder(campo: String) = adicionarFotoSecao(campo)

    fun removerUltimaFotoSecao(campo: String) {
        atualizarSecao(campo) { secao ->
            if (secao.fotos.isEmpty()) secao else secao.copy(fotos = secao.fotos.dropLast(1))
        }
    }

    fun removerFotoSecao(campo: String, foto: FotoAnexo) {
        atualizarSecao(campo) { secao ->
            secao.copy(fotos = secao.fotos.filter { it.id != foto.id })
        }
    }

    fun adicionarFotoInformacoesAdicionais() {
        scope.launch {
            val captured = PlatformServices.capturePhoto()
            if (captured == null) {
                _mensagem.value = "Captura de foto cancelada ou indisponível."
                return@launch
            }
            val stampedBytes = PlatformImage.applyStamp(
                captured.path,
                PhotoStampData(
                    tstResponsavel = _form.value.tstResponsavel,
                    pergunta = "Informações adicionais",
                    resposta = "OBS",
                    responsavelFrente = _form.value.responsavelFrente,
                    localTexto = _form.value.localTexto,
                    dataHoraMs = currentTimeMillis(),
                    latitude = captured.latitude ?: _form.value.latitude,
                    longitude = captured.longitude ?: _form.value.longitude,
                    numeroInspecao = _idEdicao.value
                )
            )
            if (stampedBytes == null || stampedBytes.isEmpty()) {
                _mensagem.value =
                    "Não foi possível carimbar a foto. No iPhone, use a câmera do app " +
                        "(JPEG) — fotos HEIC da galeria não são suportadas no navegador."
                return@launch
            }
            val embedded = embedPhotoBase64(stampedBytes)
            val path = PlatformServices.publishPhoto(captured.path)
            val foto = FotoAnexo(
                path = path,
                capturadoEm = currentTimeMillis(),
                latitude = captured.latitude ?: _form.value.latitude,
                longitude = captured.longitude ?: _form.value.longitude,
                conteudoBase64 = embedded
            )
            _form.value = _form.value.copy(
                informacoesAdicionaisFotos = _form.value.informacoesAdicionaisFotos + foto
            )
            persistirRascunhoDebounced()
        }
    }

    fun removerFotoInformacoesAdicionais(foto: FotoAnexo) {
        _form.value = _form.value.copy(
            informacoesAdicionaisFotos = _form.value.informacoesAdicionaisFotos.filter { it.id != foto.id }
        )
        persistirRascunhoDebounced()
    }

    private fun atualizarSecao(campo: String, block: (SecaoSimNao) -> SecaoSimNao) {
        _form.value = when (campo) {
            "desvios" -> _form.value.copy(desviosEncontrados = block(_form.value.desviosEncontrados))
            "acoesCorretivas" -> _form.value.copy(acoesCorretivas = block(_form.value.acoesCorretivas))
            else -> _form.value
        }
        persistirRascunhoDebounced()
    }

    fun capturarGps() {
        scope.launch {
            _capturandoGps.value = true
            val fix = PlatformServices.captureGps()
            if (fix != null) {
                _form.value = _form.value.copy(
                    latitude = fix.latitude,
                    longitude = fix.longitude,
                    localTexto = fix.textoLocal
                )
                persistirRascunhoDebounced()
            } else {
                _mensagem.value =
                    "Não foi possível obter o GPS. Permita a localização no navegador " +
                        "(ícone do cadeado na barra de endereço) e, no Windows, ative " +
                        "Configurações → Privacidade → Localização."
            }
            _capturandoGps.value = false
        }
    }

    fun iniciarNovaInspecao() {
        draftStore.limpar()
        _modoTreinamento.value = false
        _erros.value = emptyList()
        _idEdicao.value = null
        _form.value = FormInspecao(dataHorarioMs = currentTimeMillis())
        capturarGps()
        _mensagem.value = "Nova inspeção iniciada."
    }

    fun ativarTreinamento() {
        draftStore.limpar()
        _modoTreinamento.value = true
        _erros.value = emptyList()
        _idEdicao.value = null
        _form.value = TreinamentoDados.formularioExemplo()
        _mensagem.value = "Modo treinamento ativo (não persiste no histórico)."
    }

    fun desativarTreinamento() {
        _modoTreinamento.value = false
        iniciarNovaInspecao()
    }

    fun abrirAssinatura(campo: String) {
        _assinaturaEditando.value = campo
    }

    fun fecharAssinatura() {
        _assinaturaEditando.value = null
    }

    fun salvarAssinatura(campo: String, dados: String) {
        _form.value = when (campo) {
            "supervisor" -> _form.value.copy(assinaturaSupervisor = dados)
            "sesmt" -> _form.value.copy(assinaturaSesmt = dados)
            else -> _form.value
        }
        _assinaturaEditando.value = null
        persistirRascunhoDebounced()
    }

    fun erroNoCampo(campo: String): String? =
        _erros.value.find { it.campo == campo }?.mensagem

    fun validarESalvar() {
        val atual = _form.value.copy(dataHorarioMs = currentTimeMillis())
        _form.value = atual
        val erros = InspecaoValidacao.validar(atual)
        _erros.value = erros
        if (erros.isNotEmpty()) {
            _mensagem.value = "Há ${erros.size} pendência(s). Verifique os campos marcados."
            return
        }
        if (_modoTreinamento.value) {
            _mensagem.value = "Treinamento validado com sucesso (não salvo no histórico)."
            _form.value = TreinamentoDados.formularioExemplo()
            return
        }
        scope.launch {
            val result = withContext(Dispatchers.Default) {
                store.salvar(atual, _idEdicao.value)
            }
            recarregarHistorico()
            if (!result.gravouCache) {
                // Memória tem a inspeção nesta sessão, mas fechar o browser perde tudo.
                _mensagem.value =
                    "ATENÇÃO: não gravou no cache do navegador. Não feche o app — " +
                        "exporte o PDF agora ou toque em Salvar de novo. " +
                        (result.erro ?: "")
                _tab.value = AppTab.HISTORICO
                return@launch
            }
            withContext(Dispatchers.Default) { draftStore.limpar() }
            _idEdicao.value = null
            _form.value = FormInspecao(dataHorarioMs = currentTimeMillis())
            capturarGps()

            var uploadMsg = ""
            if (AuthApi.currentSession() != null) {
                _mensagem.value = "Inspeção salva. Enviando PDF/Excel ao servidor..."
                val upload = runCatching {
                    val pdfBytes = JpegPdfBuilder.build(result.inspecao)
                    val excelBytes = SharedExcelBuilder.build(result.inspecao)
                    val jsonText = FormJson.inspecaoToJson(
                        result.inspecao.copy(form = result.inspecao.form.semConteudoBase64())
                    )
                    AuthApi.uploadInspection(
                        localId = result.inspecao.id,
                        createdAt = result.inspecao.criadoEm,
                        summaryTst = result.inspecao.form.tstResponsavel,
                        summaryLocal = result.inspecao.form.localTexto,
                        summaryEfetivo = result.inspecao.form.efetivo.ifBlank { null },
                        summaryObra = result.inspecao.form.obra.ifBlank { null },
                        dataHorarioMs = result.inspecao.form.dataHorarioMs,
                        formType = FormTipo.INSPECAO_CAMPO.id,
                        pdfFileName = ExportNames.pdf(result.inspecao),
                        excelFileName = ExportNames.excel(result.inspecao),
                        pdfBytes = pdfBytes,
                        excelBytes = excelBytes,
                        jsonText = jsonText
                    )
                }.getOrElse { Result.failure(it) }
                uploadMsg = upload.fold(
                    onSuccess = { " Disponível para o admin (30 dias)." },
                    onFailure = { " (aviso: não enviou ao servidor: ${it.message})" }
                )
                recarregarHistoricoRemoto()
            }

            _mensagem.value = when {
                result.usouJsonEnxuto ->
                    "Inspeção salva (lista + refs das fotos).$uploadMsg"
                else -> "Inspeção salva no aparelho.$uploadMsg"
            }
            _tab.value = AppTab.HUB
        }
    }

    fun carregarParaEdicao(inspecao: InspecaoCompleta) {
        _modoTreinamento.value = false
        _formTipoAtivo.value = inspecao.formTipo
        _erros.value = emptyList()
        _idEdicao.value = inspecao.id
        when (inspecao.formTipo) {
            FormTipo.INSPECAO_CAMPO -> {
                _form.value = inspecao.form
            }
            FormTipo.RELATORIO_FOTO_ALOJAMENTO -> {
                _relatorioForm.value = inspecao.relatorioFoto
                    ?: FormRelatorioFoto(dataHorarioMs = currentTimeMillis())
            }
            FormTipo.CHECKLIST_ALOJAMENTO -> {
                _checklistForm.value = inspecao.checklistAlojamento
                    ?: FormChecklistAlojamento(dataHorarioMs = currentTimeMillis())
            }
            FormTipo.RELATORIO_ALOJAMENTO -> {
                _relatorioForm.value = inspecao.relatorioFoto
                    ?: FormRelatorioFoto(dataHorarioMs = currentTimeMillis())
                _checklistForm.value = inspecao.checklistAlojamento
                    ?: FormChecklistAlojamento(dataHorarioMs = currentTimeMillis())
            }
            FormTipo.COMUNICACAO_OCORRENCIAS -> {
                _ocorrenciasForm.value = inspecao.comunicacaoOcorrencias
                    ?: FormComunicacaoOcorrencias(dataHorarioMs = currentTimeMillis())
            }
        }
        _tab.value = AppTab.FORM
        _mensagem.value = "Editando ${inspecao.formTipo.rotuloCurto} #${inspecao.id}"
    }

    fun aplicarConfiguracao(config: AppConfig): Boolean {
        if (config.camposAtivos().isEmpty()) {
            _mensagem.value = "Mantenha ao menos um campo de verificação ativo na Inspeção de Campo."
            return false
        }
        if (config.camposAlojamentoChecklistAtivos().isEmpty() &&
            config.camposAlojamentoFotoAtivos().isEmpty()
        ) {
            _mensagem.value = "Mantenha ao menos um item ativo no Relatório Alojamento."
            return false
        }
        if (config.camposOcorrencias.none { it.ativo }) {
            _mensagem.value = "Mantenha ao menos um bloco ativo em Comunicação de ocorrências."
            return false
        }
        _appConfig.value = config
        InspecaoCatalog.recarregar(config)
        _form.value = remanejarItens(_form.value)
        _relatorioForm.value = remanejarItensRelatorio(_relatorioForm.value)
        _checklistForm.value = remanejarItensChecklist(_checklistForm.value)
        _erros.value = emptyList()
        _mensagem.value = "Configuração aplicada."
        scope.launch {
            withContext(Dispatchers.Default) { configStore.salvar(config) }
        }
        return true
    }

    fun definirBannerDaGaleria() {
        scope.launch {
            val picked = PlatformServices.pickImage()
            if (picked == null) {
                _mensagem.value = "Seleção de banner cancelada."
                return@launch
            }
            val bytes = PlatformServices.loadImageBytes(picked.path)
            if (bytes == null) {
                _mensagem.value = "Não foi possível ler a imagem."
                return@launch
            }
            val path = PlatformServices.saveBannerImage(bytes)
            if (path == null) {
                _mensagem.value = "Falha ao salvar banner."
                return@launch
            }
            val atual = withContext(Dispatchers.Default) {
                configStore.salvar(_appConfig.value.copy(bannerPath = path))
            }
            _appConfig.value = atual
            _mensagem.value = "Banner atualizado."
        }
    }

    fun restaurarBannerPadrao() {
        scope.launch {
            val atual = withContext(Dispatchers.Default) {
                configStore.salvar(_appConfig.value.copy(bannerPath = null))
            }
            _appConfig.value = atual
            _mensagem.value = "Banner padrão restaurado."
        }
    }

    fun exportarConfig() {
        scope.launch {
            val path = withContext(Dispatchers.Default) { configStore.exportarJsonPath() }
            PlatformFiles.shareFile(path, "application/json", "Compartilhar configuração")
        }
    }

    fun importarConfigTexto(json: String) {
        scope.launch {
            runCatching {
                val cfg = withContext(Dispatchers.Default) { configStore.importarJson(json) }
                _appConfig.value = cfg
                _form.value = remanejarItens(_form.value)
                _relatorioForm.value = remanejarItensRelatorio(_relatorioForm.value)
                _checklistForm.value = remanejarItensChecklist(_checklistForm.value)
                _mensagem.value = "Configuração importada."
            }.onFailure {
                _mensagem.value = "Falha ao importar: ${it.message}"
            }
        }
    }

    fun exportarPdf(inspecao: InspecaoCompleta) {
        scope.launch {
            _historico.value = HistoricoUiState(exportandoId = inspecao.id, mensagem = "Gerando PDF...")
            runCatching {
                // Main: na Web, IDB/canvas do loadImageBytes/toJpegBytes precisam do event loop da UI.
                val path = SharedExporter.exportarPdf(inspecao)
                PlatformFiles.shareFile(path, "application/pdf", "Compartilhar PDF")
                _historico.value = HistoricoUiState(mensagem = "PDF gerado.")
            }.onFailure {
                _historico.value = HistoricoUiState(mensagem = "Erro PDF: ${it.message}")
            }
        }
    }

    fun exportarExcel(inspecao: InspecaoCompleta) {
        scope.launch {
            _historico.value = HistoricoUiState(exportandoId = inspecao.id, mensagem = "Gerando Excel...")
            runCatching {
                val path = SharedExporter.exportarExcel(inspecao)
                PlatformFiles.shareFile(
                    path,
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    "Compartilhar Excel"
                )
                _historico.value = HistoricoUiState(mensagem = "Excel gerado.")
            }.onFailure {
                _historico.value = HistoricoUiState(mensagem = "Erro Excel: ${it.message}")
            }
        }
    }

    fun exportarMes(ano: Int, mes: Int) {
        scope.launch {
            _historico.value = HistoricoUiState(exportandoLote = true, mensagem = "Gerando ZIP do mês...")
            runCatching {
                val lista = _inspecoes.value.filter {
                    yearOf(it.criadoEm) == ano && monthOf(it.criadoEm) == mes
                }
                if (lista.isEmpty()) error("Nenhuma inspeção neste mês.")
                val path = withContext(Dispatchers.Default) {
                    SharedExporter.exportarMesZip(lista, ano, mes)
                }
                PlatformFiles.shareFile(path, "application/zip", "Compartilhar mês")
                _historico.value = HistoricoUiState(mensagem = "ZIP do mês gerado.")
            }.onFailure {
                _historico.value = HistoricoUiState(mensagem = "Erro ZIP: ${it.message}")
            }
        }
    }

    /**
     * Excel gerencial completo: Resumo / Respostas / Ações / Dashboard (tabelas).
     * Baixa o JSON de cada remota (quando disponível) e inclui locais ainda não enviados.
     */
    fun exportarConsolidado(
        remotas: List<br.com.htms.inspeccaocampo.auth.RemoteInspection>,
        locais: List<br.com.htms.inspeccaocampo.data.InspecaoCompleta>,
        deLabel: String,
        ateLabel: String
    ) {
        scope.launch {
            _historico.value = HistoricoUiState(
                exportandoConsolidado = true,
                mensagem = "Preparando Excel consolidado..."
            )
            runCatching {
                if (_authUser.value?.isAdmin != true) {
                    error("Apenas administradores podem baixar o Excel consolidado.")
                }
                if (remotas.isEmpty() && locais.isEmpty()) {
                    error("Nenhuma inspeção no período filtrado.")
                }
                val items = mutableListOf<br.com.htms.inspeccaocampo.export.ConsolidadoInspecao>()
                var semJson = 0
                var falhas = 0
                remotas.forEachIndexed { index, remote ->
                    _historico.value = HistoricoUiState(
                        exportandoConsolidado = true,
                        mensagem = "Baixando dados ${index + 1}/${remotas.size}..."
                    )
                    if (!remote.hasJson) {
                        semJson++
                        return@forEachIndexed
                    }
                    runCatching {
                        val bytes = AuthApi.downloadInspectionBytes(remote.id, "json").getOrThrow()
                        val json = bytes.decodeToString()
                        val insp = br.com.htms.inspeccaocampo.data.FormJson.inspecaoFromJson(json)
                        items += br.com.htms.inspeccaocampo.export.ConsolidadoInspecao(
                            username = remote.username.orEmpty()
                                .ifBlank { _authUser.value?.username.orEmpty() },
                            remoteId = remote.id,
                            inspecao = insp
                        )
                    }.onFailure {
                        falhas++
                    }
                }
                val userName = _authUser.value?.username.orEmpty()
                locais.forEach { insp ->
                    items += br.com.htms.inspeccaocampo.export.ConsolidadoInspecao(
                        username = userName,
                        remoteId = null,
                        inspecao = insp
                    )
                }
                if (items.isEmpty()) {
                    error(
                        when {
                            semJson > 0 && falhas == 0 ->
                                "Nenhuma inspeção com JSON completo no período ($semJson sem dados detalhados)."
                            falhas > 0 ->
                                "Não foi possível baixar os dados detalhados ($falhas falha(s))."
                            else -> "Nenhuma inspeção com dados para consolidar."
                        }
                    )
                }
                _historico.value = HistoricoUiState(
                    exportandoConsolidado = true,
                    mensagem = "Gerando Excel (${items.size} inspeções)..."
                )
                val path = withContext(Dispatchers.Default) {
                    SharedExporter.exportarConsolidado(items, deLabel, ateLabel)
                }
                PlatformFiles.shareFile(
                    path,
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    "Excel consolidado"
                )
                val aviso = buildString {
                    if (semJson > 0) append(" $semJson sem JSON.")
                    if (falhas > 0) append(" $falhas falha(s) no download.")
                }
                _historico.value = HistoricoUiState(
                    mensagem = "Excel completo gerado (${items.size} inspeções).$aviso"
                )
            }.onFailure {
                _historico.value = HistoricoUiState(
                    mensagem = "Erro Excel consolidado: ${it.message}"
                )
            }
        }
    }

    fun openNrVigente() {
        PlatformServices.openUrl(
            "https://www.gov.br/trabalho-e-emprego/pt-br/acesso-a-informacao/participacao-social/conselhos-e-orgaos-colegiados/comissao-tripartite-partitaria-permanente/normas-regulamentadora/normas-regulamentadoras-vigentes"
        )
    }

    fun tentarAbrirConfig(senha: String): Boolean {
        if (!AdminSenha.validar(senha)) return false
        _tab.value = AppTab.CONFIG
        return true
    }

    /** Admin abre Config sem PIN local (já autenticado no login). */
    fun abrirConfigComoAdmin(): Boolean {
        if (!isAdmin) return false
        _tab.value = AppTab.CONFIG
        return true
    }

    private fun remanejarItens(form: FormInspecao): FormInspecao {
        val atuais = InspecaoCatalog.itensPadrao()
        val porTitulo = form.itens.associateBy { it.titulo }
        val porId = form.itens.associateBy { it.id }
        val itens = atuais.map { novo ->
            val antigo = porId[novo.id] ?: porTitulo[novo.titulo]
            if (antigo == null) novo
            else novo.copy(
                resposta = antigo.resposta,
                fotos = antigo.fotos,
                justificativa = antigo.justificativa
            )
        }
        return form.copy(itens = itens)
    }

    private fun remanejarItensRelatorio(form: FormRelatorioFoto): FormRelatorioFoto {
        val atuais = RelatorioFotoCatalog.itensPadrao()
        val porId = form.itens.associateBy { it.id }
        val itens = atuais.map { novo ->
            val antigo = porId[novo.id]
            if (antigo == null) novo
            else novo.copy(
                resposta = antigo.resposta,
                fotos = antigo.fotos,
                justificativa = antigo.justificativa,
                valorExtra = antigo.valorExtra
            )
        }
        return form.copy(itens = itens)
    }

    private fun remanejarItensChecklist(form: FormChecklistAlojamento): FormChecklistAlojamento {
        val atuais = ChecklistAlojamentoCatalog.itensPadrao()
        val porId = form.itens.associateBy { it.id }
        val itens = atuais.map { novo ->
            val antigo = porId[novo.id]
            if (antigo == null) novo
            else novo.copy(
                resposta = antigo.resposta,
                fotos = antigo.fotos,
                justificativa = antigo.justificativa,
                valorExtra = antigo.valorExtra
            )
        }
        return form.copy(itens = itens)
    }

    fun baixarRemoto(remoteId: String, kind: String, fileName: String) {
        scope.launch {
            _historico.value = HistoricoUiState(
                exportandoRemoteId = remoteId,
                mensagem = "Baixando ${kind.uppercase()}..."
            )
            runCatching {
                val bytes = AuthApi.downloadInspectionBytes(remoteId, kind).getOrThrow()
                val path = PlatformFiles.join(PlatformFiles.cacheDir(), fileName)
                PlatformFiles.writeBytes(path, bytes)
                val mime = when (kind) {
                    "pdf" -> "application/pdf"
                    "excel" -> "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    else -> "application/json"
                }
                PlatformFiles.shareFile(path, mime, "Baixar ${kind.uppercase()}")
                _historico.value = HistoricoUiState(mensagem = "${kind.uppercase()} baixado.")
            }.onFailure {
                _historico.value = HistoricoUiState(mensagem = "Erro ao baixar: ${it.message}")
            }
        }
    }

    /** Admin: exclui vistoria remota e atualiza a lista. */
    fun excluirRemoto(remoteId: String) {
        scope.launch {
            _historico.value = _historico.value.copy(
                exportandoRemoteId = remoteId,
                mensagem = "Excluindo inspeção..."
            )
            AuthApi.deleteInspection(remoteId)
                .onSuccess {
                    _remoteInspections.value =
                        _remoteInspections.value.filterNot { it.id == remoteId }
                    _historico.value = HistoricoUiState(mensagem = "Inspeção excluída do servidor.")
                    recarregarHistoricoRemoto()
                }
                .onFailure {
                    _historico.value = HistoricoUiState(
                        mensagem = "Erro ao excluir: ${it.message}"
                    )
                }
        }
    }

    private fun recarregarHistorico() {
        _inspecoes.value = store.listar()
        if (AuthApi.currentSession() != null) {
            scope.launch { recarregarHistoricoRemoto() }
        }
    }

    private suspend fun recarregarHistoricoRemoto() {
        AuthApi.listInspections()
            .onSuccess { _remoteInspections.value = it }
            .onFailure {
                // Mantém local; avisa só se admin/histórico remoto esperado
                if (_remoteInspections.value.isEmpty()) {
                    _historico.value = _historico.value.copy(
                        mensagem = "Histórico remoto indisponível: ${it.message}"
                    )
                }
            }
    }

    fun atualizarHistoricoRemoto() {
        scope.launch { recarregarHistoricoRemoto() }
    }

    private fun persistirRascunhoDebounced() {
        if (_modoTreinamento.value) return
        val form = _form.value
        val id = _idEdicao.value
        scope.launch(Dispatchers.Default) {
            if (form.temConteudoRascunho()) draftStore.salvar(form, id)
            else draftStore.limpar()
        }
    }

    fun salvarAssinaturaChecklist(campo: String, dados: String) {
        val f = _checklistForm.value
        _checklistForm.value = when (campo) {
            "inspecionadoPor" -> f.copy(
                inspecionadoPor = f.inspecionadoPor.copy(assinatura = dados)
            )
            "acompanhadoPor" -> f.copy(
                acompanhadoPor = f.acompanhadoPor.copy(assinatura = dados)
            )
            "engenheiroResidente" -> f.copy(
                engenheiroResidente = f.engenheiroResidente.copy(assinatura = dados)
            )
            else -> f
        }
        _assinaturaEditando.value = null
    }

    fun atualizarRelatorio(block: (FormRelatorioFoto) -> FormRelatorioFoto) {
        _relatorioForm.value = block(_relatorioForm.value)
        if (_formTipoAtivo.value == FormTipo.RELATORIO_ALOJAMENTO) {
            syncCamposCompartilhadosAlojamento()
        }
    }

    fun atualizarItemRelatorio(itemId: String, block: (ItemConformidade) -> ItemConformidade) {
        _relatorioForm.value = _relatorioForm.value.copy(
            itens = _relatorioForm.value.itens.map { if (it.id == itemId) block(it) else it }
        )
    }

    fun definirRespostaRelatorio(itemId: String, resposta: RespostaConformidade) {
        atualizarItemRelatorio(itemId) { it.copy(resposta = resposta) }
    }

    fun capturarGpsRelatorio() {
        scope.launch {
            _capturandoGps.value = true
            val fix = PlatformServices.captureGps()
            if (fix != null) {
                _relatorioForm.value = _relatorioForm.value.copy(
                    latitude = fix.latitude,
                    longitude = fix.longitude,
                    localTexto = fix.textoLocal
                )
                if (_formTipoAtivo.value == FormTipo.RELATORIO_ALOJAMENTO) {
                    syncCamposCompartilhadosAlojamento()
                }
            } else {
                _mensagem.value =
                    "Não foi possível obter o GPS. Permita a localização no navegador."
            }
            _capturandoGps.value = false
        }
    }

    fun capturarGpsRelatorioAlojamento() {
        scope.launch {
            _capturandoGps.value = true
            val fix = PlatformServices.captureGps()
            if (fix != null) {
                _relatorioForm.value = _relatorioForm.value.copy(
                    latitude = fix.latitude,
                    longitude = fix.longitude,
                    localTexto = fix.textoLocal
                )
                syncCamposCompartilhadosAlojamento()
            } else {
                _mensagem.value =
                    "Não foi possível obter o GPS. Permita a localização no navegador."
            }
            _capturandoGps.value = false
        }
    }

    /** Espelha obra/endereço/GPS da Parte 1 (fotográfico) na Parte 2 (checklist). */
    fun syncCamposCompartilhadosAlojamento() {
        val r = _relatorioForm.value
        _checklistForm.value = _checklistForm.value.copy(
            endereco = r.endereco.ifBlank { _checklistForm.value.endereco },
            obra = r.obra.ifBlank { _checklistForm.value.obra },
            latitude = r.latitude ?: _checklistForm.value.latitude,
            longitude = r.longitude ?: _checklistForm.value.longitude,
            localTexto = r.localTexto.ifBlank { _checklistForm.value.localTexto }
        )
    }

    fun atualizarRelatorioCombinado(block: (FormRelatorioFoto) -> FormRelatorioFoto) {
        _relatorioForm.value = block(_relatorioForm.value)
        syncCamposCompartilhadosAlojamento()
    }

    fun capturarGpsChecklist() {
        scope.launch {
            _capturandoGps.value = true
            val fix = PlatformServices.captureGps()
            if (fix != null) {
                _checklistForm.value = _checklistForm.value.copy(
                    latitude = fix.latitude,
                    longitude = fix.longitude,
                    localTexto = fix.textoLocal
                )
            } else {
                _mensagem.value =
                    "Não foi possível obter o GPS. Permita a localização no navegador " +
                        "(ícone do cadeado na barra de endereço) e, no Windows, ative " +
                        "Configurações → Privacidade → Localização."
            }
            _capturandoGps.value = false
        }
    }

    fun adicionarFotoRelatorio(itemId: String) {
        scope.launch {
            val captured = PlatformServices.capturePhoto()
            if (captured == null) {
                _mensagem.value = "Captura de foto cancelada ou indisponível."
                return@launch
            }
            val item = _relatorioForm.value.itens.find { it.id == itemId }
            val stampedBytes = PlatformImage.applyStamp(
                captured.path,
                PhotoStampData(
                    tstResponsavel = _relatorioForm.value.responsavelAlojamento,
                    pergunta = item?.tituloNumerado ?: itemId,
                    resposta = item?.resposta?.rotuloSimNao ?: "Sim",
                    responsavelFrente = _relatorioForm.value.responsavelAlojamento,
                    localTexto = _relatorioForm.value.endereco.ifBlank {
                        _relatorioForm.value.localTexto
                    },
                    dataHoraMs = currentTimeMillis(),
                    latitude = captured.latitude ?: _relatorioForm.value.latitude,
                    longitude = captured.longitude ?: _relatorioForm.value.longitude,
                    numeroInspecao = _idEdicao.value
                )
            )
            if (stampedBytes == null || stampedBytes.isEmpty()) {
                _mensagem.value = "Não foi possível carimbar a foto."
                return@launch
            }
            val embedded = embedPhotoBase64(stampedBytes)
            val path = PlatformServices.publishPhoto(captured.path)
            val foto = FotoAnexo(
                path = path,
                capturadoEm = currentTimeMillis(),
                latitude = captured.latitude ?: _relatorioForm.value.latitude,
                longitude = captured.longitude ?: _relatorioForm.value.longitude,
                conteudoBase64 = embedded
            )
            atualizarItemRelatorio(itemId) {
                it.copy(
                    fotos = it.fotos + foto,
                    resposta = it.resposta ?: RespostaConformidade.C
                )
            }
        }
    }

    fun removerFotoRelatorio(itemId: String, foto: FotoAnexo) {
        atualizarItemRelatorio(itemId) { item ->
            item.copy(fotos = item.fotos.filter { it.id != foto.id })
        }
    }

    fun adicionarFotoObservacoesRelatorio() {
        scope.launch {
            val captured = PlatformServices.capturePhoto()
            if (captured == null) {
                _mensagem.value = "Captura de foto cancelada ou indisponível."
                return@launch
            }
            val stampedBytes = PlatformImage.applyStamp(
                captured.path,
                PhotoStampData(
                    tstResponsavel = _relatorioForm.value.responsavelAlojamento,
                    pergunta = RelatorioFotoCatalog.SECAO_OBSERVACOES,
                    resposta = "OBS",
                    responsavelFrente = _relatorioForm.value.responsavelAlojamento,
                    localTexto = _relatorioForm.value.endereco.ifBlank {
                        _relatorioForm.value.localTexto
                    },
                    dataHoraMs = currentTimeMillis(),
                    latitude = captured.latitude ?: _relatorioForm.value.latitude,
                    longitude = captured.longitude ?: _relatorioForm.value.longitude,
                    numeroInspecao = _idEdicao.value
                )
            )
            if (stampedBytes == null || stampedBytes.isEmpty()) {
                _mensagem.value = "Não foi possível carimbar a foto."
                return@launch
            }
            val embedded = embedPhotoBase64(stampedBytes)
            val path = PlatformServices.publishPhoto(captured.path)
            val foto = FotoAnexo(
                path = path,
                capturadoEm = currentTimeMillis(),
                latitude = captured.latitude ?: _relatorioForm.value.latitude,
                longitude = captured.longitude ?: _relatorioForm.value.longitude,
                conteudoBase64 = embedded
            )
            _relatorioForm.value = _relatorioForm.value.copy(
                observacoesFotos = _relatorioForm.value.observacoesFotos + foto
            )
        }
    }

    fun removerFotoObservacoesRelatorio(foto: FotoAnexo) {
        _relatorioForm.value = _relatorioForm.value.copy(
            observacoesFotos = _relatorioForm.value.observacoesFotos.filter { it.id != foto.id }
        )
    }

    fun validarESalvarRelatorio() {
        val atual = _relatorioForm.value.copy(dataHorarioMs = currentTimeMillis())
        _relatorioForm.value = atual
        val erros = AlojamentoValidacao.validarRelatorio(atual)
        _erros.value = erros
        if (erros.isNotEmpty()) {
            _mensagem.value = "Há ${erros.size} pendência(s). Verifique os campos marcados."
            return
        }
        scope.launch {
            val completa = InspecaoCompleta(
                id = _idEdicao.value ?: 0L,
                formTipo = FormTipo.RELATORIO_FOTO_ALOJAMENTO,
                form = FormInspecao(
                    tstResponsavel = atual.responsavelAlojamento,
                    dataHorarioMs = atual.dataHorarioMs,
                    latitude = atual.latitude,
                    longitude = atual.longitude,
                    localTexto = atual.endereco.ifBlank { atual.localTexto },
                    obra = atual.obra
                ),
                relatorioFoto = atual
            )
            val result = withContext(Dispatchers.Default) {
                store.salvarCompleta(completa, _idEdicao.value)
            }
            recarregarHistorico()
            if (!result.gravouCache) {
                _mensagem.value =
                    "ATENÇÃO: não gravou no cache. Exporte agora ou salve de novo. " +
                        (result.erro ?: "")
                _tab.value = AppTab.HISTORICO
                return@launch
            }
            _idEdicao.value = null
            _relatorioForm.value = FormRelatorioFoto(dataHorarioMs = currentTimeMillis())
            var uploadMsg = ""
            if (AuthApi.currentSession() != null) {
                _mensagem.value = "Relatório salvo. Enviando ao servidor..."
                val upload = runCatching {
                    val pdfBytes = JpegPdfBuilder.buildRelatorio(result.inspecao)
                    val excelBytes = SharedExcelBuilder.build(result.inspecao)
                    val jsonText = FormJson.inspecaoToJson(
                        result.inspecao.copy(
                            relatorioFoto = result.inspecao.relatorioFoto?.semConteudoBase64()
                        )
                    )
                    AuthApi.uploadInspection(
                        localId = result.inspecao.id,
                        createdAt = result.inspecao.criadoEm,
                        summaryTst = atual.responsavelAlojamento,
                        summaryLocal = atual.endereco,
                        summaryEfetivo = atual.quantidadeFuncionarios.ifBlank { null },
                        summaryObra = atual.obra.ifBlank { null },
                        dataHorarioMs = atual.dataHorarioMs,
                        formType = FormTipo.RELATORIO_FOTO_ALOJAMENTO.id,
                        pdfFileName = ExportNames.pdf(result.inspecao),
                        excelFileName = ExportNames.excel(result.inspecao),
                        pdfBytes = pdfBytes,
                        excelBytes = excelBytes,
                        jsonText = jsonText
                    )
                }.getOrElse { Result.failure(it) }
                uploadMsg = upload.fold(
                    onSuccess = { " Disponível para o admin (30 dias)." },
                    onFailure = { " (aviso: não enviou ao servidor: ${it.message})" }
                )
                recarregarHistoricoRemoto()
            }
            _mensagem.value = "Relatório fotográfico salvo.$uploadMsg"
            _tab.value = AppTab.HUB
        }
    }

    fun atualizarChecklist(block: (FormChecklistAlojamento) -> FormChecklistAlojamento) {
        _checklistForm.value = block(_checklistForm.value)
    }

    fun atualizarItemChecklist(itemId: String, block: (ItemConformidade) -> ItemConformidade) {
        _checklistForm.value = _checklistForm.value.copy(
            itens = _checklistForm.value.itens.map { if (it.id == itemId) block(it) else it }
        )
    }

    fun definirRespostaChecklist(itemId: String, resposta: RespostaConformidade) {
        atualizarItemChecklist(itemId) { it.copy(resposta = resposta) }
    }

    fun validarESalvarChecklist() {
        val ms = currentTimeMillis()
        val formatado = formatDateBr(ms)
        val partes = formatado.split(' ', limit = 2)
        val atual = _checklistForm.value.copy(
            dataHorarioMs = ms,
            dataInspecao = partes.getOrElse(0) { formatado },
            horaInspecao = partes.getOrElse(1) { "" }
        )
        _checklistForm.value = atual
        val erros = AlojamentoValidacao.validarChecklist(atual)
        _erros.value = erros
        if (erros.isNotEmpty()) {
            _mensagem.value = "Há ${erros.size} pendência(s). Verifique os campos marcados."
            return
        }
        scope.launch {
            val completa = InspecaoCompleta(
                id = _idEdicao.value ?: 0L,
                formTipo = FormTipo.CHECKLIST_ALOJAMENTO,
                form = FormInspecao(
                    tstResponsavel = atual.inspecionadoPor.nome,
                    dataHorarioMs = atual.dataHorarioMs,
                    latitude = atual.latitude,
                    longitude = atual.longitude,
                    localTexto = atual.endereco.ifBlank { atual.localTexto },
                    obra = atual.obra
                ),
                checklistAlojamento = atual
            )
            val result = withContext(Dispatchers.Default) {
                store.salvarCompleta(completa, _idEdicao.value)
            }
            recarregarHistorico()
            if (!result.gravouCache) {
                _mensagem.value =
                    "ATENÇÃO: não gravou no cache. Exporte agora ou salve de novo. " +
                        (result.erro ?: "")
                _tab.value = AppTab.HISTORICO
                return@launch
            }
            _idEdicao.value = null
            _checklistForm.value = FormChecklistAlojamento(dataHorarioMs = currentTimeMillis())
            var uploadMsg = ""
            if (AuthApi.currentSession() != null) {
                _mensagem.value = "Checklist salvo. Enviando ao servidor..."
                val upload = runCatching {
                    val pdfBytes = JpegPdfBuilder.buildChecklist(result.inspecao)
                    val excelBytes = SharedExcelBuilder.build(result.inspecao)
                    val jsonText = FormJson.inspecaoToJson(result.inspecao)
                    AuthApi.uploadInspection(
                        localId = result.inspecao.id,
                        createdAt = result.inspecao.criadoEm,
                        summaryTst = atual.inspecionadoPor.nome,
                        summaryLocal = atual.endereco,
                        summaryEfetivo = null,
                        summaryObra = atual.obra.ifBlank { null },
                        dataHorarioMs = atual.dataHorarioMs,
                        formType = FormTipo.CHECKLIST_ALOJAMENTO.id,
                        pdfFileName = ExportNames.pdf(result.inspecao),
                        excelFileName = ExportNames.excel(result.inspecao),
                        pdfBytes = pdfBytes,
                        excelBytes = excelBytes,
                        jsonText = jsonText
                    )
                }.getOrElse { Result.failure(it) }
                uploadMsg = upload.fold(
                    onSuccess = { " Disponível para o admin (30 dias)." },
                    onFailure = { " (aviso: não enviou ao servidor: ${it.message})" }
                )
                recarregarHistoricoRemoto()
            }
            _mensagem.value = "Checklist de alojamento salvo.$uploadMsg"
            _tab.value = AppTab.HUB
        }
    }

    fun validarESalvarRelatorioAlojamento() {
        val ms = currentTimeMillis()
        val formatado = formatDateBr(ms)
        val partes = formatado.split(' ', limit = 2)
        syncCamposCompartilhadosAlojamento()
        val part1 = _relatorioForm.value.copy(dataHorarioMs = ms)
        val part2 = _checklistForm.value.copy(
            dataHorarioMs = ms,
            dataInspecao = partes.getOrElse(0) { formatado },
            horaInspecao = partes.getOrElse(1) { "" },
            endereco = part1.endereco.ifBlank { _checklistForm.value.endereco },
            obra = part1.obra.ifBlank { _checklistForm.value.obra },
            latitude = part1.latitude ?: _checklistForm.value.latitude,
            longitude = part1.longitude ?: _checklistForm.value.longitude,
            localTexto = part1.localTexto.ifBlank { _checklistForm.value.localTexto }
        )
        _relatorioForm.value = part1
        _checklistForm.value = part2
        val erros = AlojamentoValidacao.validarRelatorio(part1) +
            AlojamentoValidacao.validarChecklist(part2)
        _erros.value = erros
        if (erros.isNotEmpty()) {
            _mensagem.value =
                "Há ${erros.size} pendência(s) nas Partes 1 e/ou 2. Verifique os campos marcados."
            return
        }
        scope.launch {
            val completa = InspecaoCompleta(
                id = _idEdicao.value ?: 0L,
                formTipo = FormTipo.RELATORIO_ALOJAMENTO,
                form = FormInspecao(
                    tstResponsavel = part1.responsavelAlojamento
                        .ifBlank { part2.inspecionadoPor.nome },
                    dataHorarioMs = ms,
                    latitude = part1.latitude,
                    longitude = part1.longitude,
                    localTexto = part1.endereco.ifBlank { part1.localTexto },
                    obra = part1.obra
                ),
                relatorioFoto = part1,
                checklistAlojamento = part2
            )
            val result = withContext(Dispatchers.Default) {
                store.salvarCompleta(completa, _idEdicao.value)
            }
            recarregarHistorico()
            if (!result.gravouCache) {
                _mensagem.value =
                    "ATENÇÃO: não gravou no cache. Exporte agora ou salve de novo. " +
                        (result.erro ?: "")
                _tab.value = AppTab.HISTORICO
                return@launch
            }
            _idEdicao.value = null
            _relatorioForm.value = FormRelatorioFoto(dataHorarioMs = currentTimeMillis())
            _checklistForm.value = FormChecklistAlojamento(dataHorarioMs = currentTimeMillis())
            var uploadMsg = ""
            if (AuthApi.currentSession() != null) {
                _mensagem.value = "Relatório Alojamento salvo. Enviando ao servidor..."
                val upload = runCatching {
                    val pdfBytes = JpegPdfBuilder.buildRelatorioAlojamento(result.inspecao)
                    val excelBytes = SharedExcelBuilder.build(result.inspecao)
                    val jsonText = FormJson.inspecaoToJson(
                        result.inspecao.copy(
                            relatorioFoto = result.inspecao.relatorioFoto?.semConteudoBase64()
                        )
                    )
                    AuthApi.uploadInspection(
                        localId = result.inspecao.id,
                        createdAt = result.inspecao.criadoEm,
                        summaryTst = part1.responsavelAlojamento
                            .ifBlank { part2.inspecionadoPor.nome },
                        summaryLocal = part1.endereco.ifBlank { part2.endereco },
                        summaryEfetivo = part1.quantidadeFuncionarios.ifBlank { null },
                        summaryObra = part1.obra.ifBlank { part2.obra }.ifBlank { null },
                        dataHorarioMs = ms,
                        formType = FormTipo.RELATORIO_ALOJAMENTO.id,
                        pdfFileName = ExportNames.pdf(result.inspecao),
                        excelFileName = ExportNames.excel(result.inspecao),
                        pdfBytes = pdfBytes,
                        excelBytes = excelBytes,
                        jsonText = jsonText
                    )
                }.getOrElse { Result.failure(it) }
                uploadMsg = upload.fold(
                    onSuccess = { " Disponível para o admin (30 dias)." },
                    onFailure = { " (aviso: não enviou ao servidor: ${it.message})" }
                )
                recarregarHistoricoRemoto()
            }
            _mensagem.value = "Relatório Alojamento salvo.$uploadMsg"
            _tab.value = AppTab.HUB
        }
    }

    fun atualizarOcorrencias(block: (FormComunicacaoOcorrencias) -> FormComunicacaoOcorrencias) {
        _ocorrenciasForm.value = block(_ocorrenciasForm.value)
    }

    fun capturarGpsOcorrencias() {
        scope.launch {
            _capturandoGps.value = true
            val fix = PlatformServices.captureGps()
            if (fix != null) {
                _ocorrenciasForm.value = _ocorrenciasForm.value.copy(
                    latitude = fix.latitude,
                    longitude = fix.longitude,
                    localTexto = fix.textoLocal
                )
            } else {
                _mensagem.value =
                    "Não foi possível obter o GPS. Permita a localização no navegador " +
                        "(ícone do cadeado na barra de endereço) e, no Windows, ative " +
                        "Configurações → Privacidade → Localização."
            }
            _capturandoGps.value = false
        }
    }

    fun adicionarFotoOcorrencias() {
        scope.launch {
            val captured = PlatformServices.capturePhoto()
            if (captured == null) {
                _mensagem.value = "Captura de foto cancelada ou indisponível."
                return@launch
            }
            val atual = _ocorrenciasForm.value
            val stampedBytes = PlatformImage.applyStamp(
                captured.path,
                PhotoStampData(
                    tstResponsavel = atual.quemReportando,
                    pergunta = "Comunicação de ocorrências",
                    resposta = atual.caracterizacao?.rotulo ?: "Foto",
                    responsavelFrente = atual.responsavelAtividade,
                    localTexto = atual.localExato.ifBlank {
                        atual.localAcidente.ifBlank { atual.localTexto }
                    },
                    dataHoraMs = currentTimeMillis(),
                    latitude = captured.latitude ?: atual.latitude,
                    longitude = captured.longitude ?: atual.longitude,
                    numeroInspecao = _idEdicao.value
                )
            )
            if (stampedBytes == null || stampedBytes.isEmpty()) {
                _mensagem.value = "Não foi possível carimbar a foto."
                return@launch
            }
            val embedded = embedPhotoBase64(stampedBytes)
            val path = PlatformServices.publishPhoto(captured.path)
            val foto = FotoAnexo(
                path = path,
                capturadoEm = currentTimeMillis(),
                latitude = captured.latitude ?: atual.latitude,
                longitude = captured.longitude ?: atual.longitude,
                conteudoBase64 = embedded
            )
            _ocorrenciasForm.value = atual.copy(fotos = atual.fotos + foto)
        }
    }

    fun removerFotoOcorrencias(foto: FotoAnexo) {
        _ocorrenciasForm.value = _ocorrenciasForm.value.copy(
            fotos = _ocorrenciasForm.value.fotos.filter { it.id != foto.id }
        )
    }

    fun validarESalvarOcorrencias() {
        val atual = _ocorrenciasForm.value.copy(dataHorarioMs = currentTimeMillis())
        _ocorrenciasForm.value = atual
        val erros = ComunicacaoOcorrenciasValidacao.validar(atual, _appConfig.value)
        _erros.value = erros
        if (erros.isNotEmpty()) {
            _mensagem.value = "Há ${erros.size} pendência(s). Verifique os campos marcados."
            return
        }
        scope.launch {
            val completa = InspecaoCompleta(
                id = _idEdicao.value ?: 0L,
                formTipo = FormTipo.COMUNICACAO_OCORRENCIAS,
                form = FormInspecao(
                    tstResponsavel = atual.quemReportando,
                    dataHorarioMs = atual.dataHorarioMs,
                    latitude = atual.latitude,
                    longitude = atual.longitude,
                    localTexto = atual.localExato.ifBlank { atual.localTexto },
                    obra = atual.obra,
                    responsavelFrente = atual.responsavelAtividade,
                    descricaoAtividade = atual.descricaoEvento
                ),
                comunicacaoOcorrencias = atual
            )
            val result = withContext(Dispatchers.Default) {
                store.salvarCompleta(completa, _idEdicao.value)
            }
            recarregarHistorico()
            if (!result.gravouCache) {
                _mensagem.value =
                    "ATENÇÃO: não gravou no cache. Exporte agora ou salve de novo. " +
                        (result.erro ?: "")
                _tab.value = AppTab.HISTORICO
                return@launch
            }
            _idEdicao.value = null
            _ocorrenciasForm.value = FormComunicacaoOcorrencias(dataHorarioMs = currentTimeMillis())
            var uploadMsg = ""
            if (AuthApi.currentSession() != null) {
                _mensagem.value = "Ocorrência salva. Enviando ao servidor..."
                val upload = runCatching {
                    val paraUpload = result.inspecao.copy(
                        comunicacaoOcorrencias = result.inspecao.comunicacaoOcorrencias?.semConteudoBase64()
                    )
                    val pdfBytes = JpegPdfBuilder.buildComunicacao(result.inspecao)
                    val excelBytes = SharedExcelBuilder.build(result.inspecao)
                    val jsonText = FormJson.inspecaoToJson(paraUpload)
                    AuthApi.uploadInspection(
                        localId = result.inspecao.id,
                        createdAt = result.inspecao.criadoEm,
                        summaryTst = atual.quemReportando,
                        summaryLocal = atual.localExato.ifBlank { atual.localAcidente },
                        summaryEfetivo = null,
                        summaryObra = atual.obra.ifBlank { null },
                        dataHorarioMs = atual.dataHorarioMs,
                        formType = FormTipo.COMUNICACAO_OCORRENCIAS.id,
                        pdfFileName = ExportNames.pdf(result.inspecao),
                        excelFileName = ExportNames.excel(result.inspecao),
                        pdfBytes = pdfBytes,
                        excelBytes = excelBytes,
                        jsonText = jsonText
                    )
                }.getOrElse { Result.failure(it) }
                uploadMsg = upload.fold(
                    onSuccess = { " Disponível para o admin (30 dias)." },
                    onFailure = { " (aviso: não enviou ao servidor: ${it.message})" }
                )
                recarregarHistoricoRemoto()
            }
            _mensagem.value = "Comunicação de ocorrências salva.$uploadMsg"
            _tab.value = AppTab.HUB
        }
    }

    private fun embedPhotoBase64(stampedBytes: ByteArray): String? {
        if (!PlatformServices.shouldEmbedPhotoBytesInForm()) return null
        if (stampedBytes.isEmpty()) return null
        // Preferir JPEG menor: se > ~1.8MB raw, ainda embute (PDF depende disso na Web).
        return PlatformServices.encodeBase64(stampedBytes)
    }

}

/** Compat: FormController antigo → AppController. */
typealias FormController = AppController
